/**
 * Function to generate schema for home page
 * @param {*} data 
 */
const generateHomePageSchema = ( data ) => {

    let schema = {
      "@type": "https://schema.org/WebPage",
      name: data?.title,
      url: process.env.GATSBY_SITE_URL,
      description: data.metaDesc,
      mentions: [
        {
          "@type": "https://schema.org/WebPage",
          url: process.env.GATSBY_SITE_URL + 'about-us/',
          "@id": process.env.GATSBY_SITE_URL + 'about-us/',
          about: {
            "@type": "Thing",
            name: "About us",
            "@id": process.env.GATSBY_SITE_URL + 'about-us/',
            sameAs: process.env.GATSBY_SITE_URL + 'about-us/',
          },
        },
      ],
      isPartOf: {
        "@type": "WebSite",
        name: 'Bedbible.com',
        url: process.env.GATSBY_SITE_URL,
        publisher: {
          "@type": "https://schema.org/Organization",
          name: "Bedbible.com",
          legalName: "Bedbible.com",
          url: process.env.GATSBY_SITE_URL,
          "@id": process.env.GATSBY_SITE_URL + '#organization',
          sameAs: [
            'https://www.facebook.com/bedbibleofficial/',
            'https://twitter.com/BedBible/',
            'https://www.youtube.com/c/BedBible/',
            'https://www.pinterest.com/Bedbible/',
            'https://www.instagram.com/bedbibleofficial/',
            'https://www.linkedin.com/company/bedbible/',
            'https://www.tiktok.com/@bedbible'
          ],
        },
      },
    }
        
    return schema

}

export default generateHomePageSchema